export const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000/api';

export const ROUTES = {
  // Marketing site — "The Riding Post" (public, served at the root)
  LANDING: '/',
  LEARN: '/learn',
  LEARN_RIDING_BASICS: '/learn/riding-basics',
  LEARN_HORSE_KNOWLEDGE: '/learn/horse-knowledge',
  LEARN_EQUESTRIAN_TERMS: '/learn/equestrian-terms',
  LEARN_PARENT_GUIDES: '/learn/parent-guides',
  LEARN_TACK_EQUIPMENT: '/learn/tack-equipment',
  RIDE_SCHOOLS: '/ride/schools',
  RIDE_PROGRAMMES: '/ride/programmes',
  RIDE_CAMPS: '/ride/camps',
  SCHOOL_PROFILE: '/ride/school-profile',
  EVENTS_INDIA: '/events/india',
  EVENTS_INTERNATIONAL: '/events/international',
  EVENT_PAGE: '/events/event',
  WATCH: '/watch',
  WATCH_EPISODE: '/watch/episode',
  WATCH_YOUNG_RIDERS: '/watch/young-riders',
  WATCH_CHAMPIONS: '/watch/champions',
  WATCH_ORIGINALS: '/watch/originals',
  ORIGINALS: '/originals',
  COMMUNITY_STORIES: '/community/stories',
  STORY_DETAIL: '/community/story',
  COMMUNITY_RIDERS: '/community/riders',
  COMMUNITY_YOUNG_RIDERS: '/community/young-riders',
  COMMUNITY_ASK: '/community/ask',
  COMMUNITY_SUBMIT: '/community/submit',
  RIDER_PROFILE: '/community/rider-profile',
  YOUNG_RIDER_PROFILE: '/community/young-rider',
  MARKETPLACE: '/marketplace',
  ACCOUNT_FEED: '/account/feed',
  ACCOUNT_PROFILE: '/account/profile',
  ACCOUNT_SAVED: '/account/saved',

  // CMS admin (gated by a separate fixed login)
  ADMIN_CMS: '/admin/cms',
  ADMIN_LOGIN: '/admin/login',

  // Application (mounted under /app)
  APP_HOME: '/app',
  LOGIN: '/app/signin',
  SIGNUP: '/app/signup',
  FORGOT_PASSWORD: '/app/forgot-password',
  SIGNUP_HORSE_OWNER: '/app/signup/horse-owner',
  SIGNUP_RIDER: '/app/signup/rider',
  HORSE_OWNER_HOME: '/app/horse-owner',
  HORSE_OWNER_PROFILE: '/app/horse-owner/profile',
  HORSE_OWNER_MY_HORSES: '/app/horse-owner/my-horses',
  HORSE_OWNER_ADD_HORSE: '/app/horse-owner/add-a-horse',
  HORSE_OWNER_HORSE_DETAIL: '/app/horse-owner/my-horses/:horseId',
  RIDER_WELCOME: '/app/signup/rider/welcome',
  HORSE_RIDER_HOME: '/app/horse-rider',
  RIDER_BROWSE_HORSES: '/app/horse-rider/browse-horses',
  RIDER_HORSE_DETAIL: '/app/horse-rider/browse-horses/:horseId',
  RIDER_PROFILES: '/app/horse-rider/rider-profiles',
  RIDER_NEW_PROFILE: '/app/horse-rider/rider-profiles/new',
  RIDER_EDIT_PROFILE: '/app/horse-rider/rider-profiles/:profileId/edit',
  RIDER_MY_EOIS: '/app/horse-rider/my-eois',
  BOOKING_REQUESTS: '/app/booking-requests',
  DASHBOARD: '/app/dashboard',
  ADMIN_APPROVAL: '/app/admin/approval',
} as const;

export const ADMIN_EMAIL = 'admin@gmail.com';

export const STORAGE_KEYS = {
  AUTH_TOKEN: 'auth_token',
  USER: 'user',
  CMS_TOKEN: 'cms_token',
  CMS_EMAIL: 'cms_email',
} as const;
